import { CSSProperties, MouseEventHandler } from 'react';
import { buildCdnSrcSet } from '@/utils/cdnResponsiveImage';

type ProductResponsiveImageProps = {
  src: string;
  alt: string;
  widths: readonly number[];
  sizes: string;
  fallbackWidth?: number;
  width: number;
  height: number;
  className?: string;
  style?: CSSProperties;
  loading?: 'eager' | 'lazy';
  fetchPriority?: 'high' | 'low' | 'auto';
  decoding?: 'async' | 'sync' | 'auto';
  onClick?: MouseEventHandler<HTMLImageElement>;
};

export default function ProductResponsiveImage({
  src,
  alt,
  widths,
  sizes,
  fallbackWidth,
  width,
  height,
  className,
  style,
  loading = 'lazy',
  fetchPriority,
  decoding = 'async',
  onClick,
}: ProductResponsiveImageProps) {
  const { src: fallbackSrc, srcSet } = buildCdnSrcSet({
    src,
    widths,
    fallbackWidth,
  });

  return (
    <img
      src={fallbackSrc}
      srcSet={srcSet}
      sizes={sizes}
      alt={alt}
      width={width}
      height={height}
      className={className}
      style={style}
      loading={loading}
      fetchPriority={fetchPriority}
      decoding={decoding}
      onClick={onClick}
    />
  );
}
